import { post } from "@/jsUtils/nodejsRequest";
import DeviceInfo from "@/jsUtils/getDeviceInfo";
export default {
  data() {
    return {
      verifyURL: "/checkhost/verify",
      //验证地址
      errorMsg: ""
    };
  },
  mounted() {
    if (!this.$route.params.QRCode && !this.$route.params.demoPath) {
      this.errorMsg = "Please access by scanning the QR code.";
      return;
    }
    //获取设备id   
    var equipmentId = DeviceInfo.getDeviceInfo({
      domain: 'http://facebrick.showbabybox.com',
      info: ["fingerprint"]
    }).fingerprint;
    //console.dir(equipmentId);
    //验证参数
    var verifyParams = {
      productTypeCode: this.$route.params.ProductTypeCode,
      QRCode: this.$route.params.QRCode,
      demoPath: this.$route.params.demoPath,
      equipmentId: equipmentId
    };
    // 参数回传主页，防止刷新丢失参数
    var query = {};
    if (verifyParams.QRCode) {
      query.QRCode = verifyParams.QRCode;
    } else if (verifyParams.demoPath) {
      query.demoPath = verifyParams.demoPath;
    }
    post(this.verifyURL, verifyParams).then(res => {
      //验证成功
      if (res.verifySuccessfully) {
        // 保存验证成功标志
        sessionStorage.setItem("verifySuccessfully", verifyParams.QRCode);
        this.$router.replace({
          path: "/",
          name: "Home",
          params: {
            verifySuccessfully: true
          },
          query: query,
          replace: true
        });
      } else {
        // console.dir("verify failed");
        // console.dir(res);

        this.errorMsg = "verify failed,error code:" + res.errorCode;
      }
    });
  },
  methods: {}
};